import { useQuery } from '@apollo/client';
import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';

import { analyticsClient } from 'src/modules/analytics/analytics';
import type { GetUserQuery } from 'src/types/graphql';

import { setCandidateId } from '../../modules/error-logger/browserLog';

import { GET_USER } from './queries.graphql';

export const useUser = () => {
  const { data, loading, error } = useQuery<GetUserQuery>(GET_USER, {
    fetchPolicy: 'network-only',
    onCompleted(queryResponse) {
      const { viewer } = queryResponse;
      if (!viewer) {
        return;
      }
      const userId = viewer._id;
      const userTrackingId = viewer.trackingId;
      setCandidateId(userId);
      analyticsClient.setState({
        isLoggedIn: true,
        loginId: userId,
        profileGuid: userTrackingId,
      });
    },
  });

  let authenticationStatus = AUTHENTICATION_TYPES.AUTH_PENDING;

  if (!loading) {
    authenticationStatus = !error
      ? AUTHENTICATION_TYPES.AUTHENTICATED
      : AUTHENTICATION_TYPES.UNAUTHENTICATED;
  }

  return { user: data?.viewer, authenticationStatus };
};
